import React from 'react';
import PropTypes from 'prop-types';
import {Col, Row} from "react-bootstrap";
import IconButton from "../IconButton";
import AdvanceTableSearchBox from "../advance-table/AdvanceTableSearchBox";

const CardTableHeader = ({onNewClick, title, showNew, globalFilter, setGlobalFilter}) => {
    return (
        <Row className="flex-between-center">
            <Col xs={4} sm="auto" className="d-flex align-items-center pe-0">
                <h2 className="h5 fs-0 mb-0 me-3 text-nowrap py-2 py-xl-0">{title}</h2>
                <div>
                    {showNew &&
                        <IconButton
                            variant="falcon-default"
                            size="sm"
                            icon="plus"
                            transform="shrink-3"
                            onClick={onNewClick}
                        >
                            <span className="d-none d-sm-inline-block ms-1">New</span>
                        </IconButton>
                    }
                </div>
            </Col>
            <Col xs={8} sm="auto" className="ms-auto text-end ps-0">
                <search title={name}>
                    <AdvanceTableSearchBox globalFilter={globalFilter} setGlobalFilter={setGlobalFilter} />
                </search>
            </Col>
        </Row>
    )
}
CardTableHeader.defaultProps = {
    showNew: true
}
CardTableHeader.propTypes = {
    onNewClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    showNew: PropTypes.bool
}
export default CardTableHeader